import * as React from 'react';

import { compose } from '../../../../../utils/component-helpers';

import { withModalActions, ModalActionProps } from '../../Modals/modalActions';
import { ModalReceiverProps } from '../../Modals/ModalManager';

import { DetailViewContracts } from '../../ContentPane/DetailView/MainTabs/DetailViewContracts';
import { MobileSubmenuSlider } from '@cube3/cubicle/src/components/Surface/MobileSubmenuSlider';

/**Display the contracts view in a modal when isMobile */

type Properties = ModalActionProps & ModalReceiverProps & MobileContracts;

interface MobileContracts {}

function MobileContracts(props: Properties): JSX.Element {
  const { modalContext, previousModal } = props;

  return (
    <MobileSubmenuSlider onClose={previousModal}>
      <DetailViewContracts asset={modalContext} />
    </MobileSubmenuSlider>
  );
}

export default compose(MobileContracts)(withModalActions);
